export default () => {

  function decodeHashId(hash) {
    if (!hash || hash.charAt(0) !== '#') return null
    let id = hash.slice(1)
    try {
      id = decodeURIComponent(id)
    } catch {
      //
    }
    return id || null
  }

  function getHashTargetElement(hash) {
    const id = decodeHashId(hash)
    if (!id) return null
    return document.getElementById(id)
  }

  function applyScrollspyTargets($links) {
    const escaper = $.escapeSelector || (typeof CSS !== 'undefined' && CSS.escape ? CSS.escape : null)
    if (!escaper) return
    $links.each(function() {
      const id = decodeHashId(this.hash)
      if (!id) return
      $(this).attr('data-target', `#${escaper(id)}`)
    })
  }

  function findNavLinkByTarget($nav, target) {
    if (!target) return $()
    return $nav.find('a').filter(function() {
      return this.getAttribute('href') === target || this.getAttribute('data-target') === target
    })
  }

  $('.js-hotel-subNavigation__contentAnchor').on('click', function(e) {
    e.preventDefault()
    const targetEl = getHashTargetElement(this.hash)
    if (!targetEl) return
    const $el = $(targetEl)

    $('html, body').animate({
      scrollTop: $el.offset().top - 205,
    }, 1000)
  })

  const $nav = $('.js-hotel-subNavigation__navCol')

  if(!$nav.length) return

  const $slideLine =  $nav.find('.js-hotel-subNavigation__navMarker')
  let $currentItem = $nav.find('.c-subNavigation__navlistItem .active')

  if ( $currentItem.length ) {
    $('.c-subNavigation__navlistItem .active').removeClass('active')
    $currentItem.parent().addClass('active')
    $currentItem = $currentItem.parent()
  }
  else {
    return
  }

  $nav.find('a').click(function(e) {
    e.preventDefault()
    $('.c-subNavigation__navlistItem').removeClass('c-subNavigation__navlistItem--active')
    const $activeEl = $(this).parent('li')
    $activeEl.addClass('c-subNavigation__navlistItem--active')
    $currentItem = $activeEl

    const targetEl = getHashTargetElement(this.hash)
    if (!targetEl) return
    const $el = $(targetEl)
    $('html, body').animate({
      scrollTop: $el.offset().top - 205,
    }, 1000)
  })

  function moveLine(item) {
    $slideLine.css({
      'width': item.width(),
      'left': item.position().left,
    })
  }

  if ($currentItem) {
    moveLine($currentItem)
  }

  $(window).resize( function() {
    moveLine($currentItem)
  })

  // Move underline on hover
  $nav.find('li').mouseenter(
    function(){
      $nav.removeClass('js-subNavigation--static')
      moveLine($(this))
      $slideLine.addClass('is-hovered')
    }
  )
  $nav.mouseleave(
    function(){
      if ($currentItem) {
        moveLine($currentItem)
      } else {
        $slideLine.width(0)
      }
      $slideLine.removeClass('is-hovered')
    }
  )


  // trigger hover event to ensure that underline has correct size
  setTimeout(function() {
    $('.c-subNavigation__navlistItem.active').trigger('mouseenter')
  }, 1000)

  applyScrollspyTargets($nav.find('a'))

  $('body').scrollspy({ target: '#c-subNavigationWrapper', offset: 206 })

  $(window).on('activate.bs.scrollspy', function (e,obj) {
    $nav.find('li').removeClass('is-underlined')
    const $activeItem = findNavLinkByTarget($nav, obj && obj.relatedTarget)
    if($activeItem.length) {
      $currentItem = $activeItem.parent()
      moveLine($currentItem)
      $('.c-subNavigation__navlistItem').removeClass('c-subNavigation__navlistItem--active')
      $activeItem.parent().addClass('c-subNavigation__navlistItem--active')
    }

  });

}
